import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export class MapScalePreview extends React.PureComponent {
    render() {
        return (_jsx("div", { className: 'rpx-mapScale', title: this.props.label, children: this.props.text }));
    }
}
//# sourceMappingURL=preview.js.map